import React, { Fragment } from 'react';
import { shapes } from '@cimpress/react-components';

import '../../css/cartoon.css';

import { classifyCartoon } from '../../services/ipaClient';
import ImageLoader from '../ImageLoader';
import ImageSelection from '../imageSelection';
import ApiTab from '../ApiTab';

function getRanking(rank) {
    if (rank === 'TBD') {
        return '';
    }
    if (rank < 0.333) {
        return 'It is a photo!';
    }
    if (rank > 0.666) {
        return 'It is a cartoon!';
    }

    return 'This picture could go either way';
}

export default class CartoonClassification extends ApiTab {
    state = {
        image: '',
        classification: 'TBD',
        loading: false,
    }

    setVariable(variable, value) {
        this.setState({ [variable]: value, loading: true }, this.updateClassification);
    }

    updateClassification = () => {
        const { image } = this.state;
        return classifyCartoon({ imageUrl: image })
            .then(classification => this.setState({ loading: false, classification }));
    }

    renderLeft = () => (
        <ImageSelection {...this.valueLink('image')} />
    )

    renderTitle = () => (
        <Fragment>
            Classifies an image either as a “Non-Cartoon” (an image with textured regions, such as photos)
            or a “Cartoon” (an image without a texture, such as line art/logos). The classification is a real
            number in the range from 0 to 1 with values close to 0 meaning “Non-Cartoon” and values close to 1
            meaning “Cartoon”.
        </Fragment>
    )

    renderRight = () => {
        const { loading, image, classification } = this.state;
        const { Spinner } = shapes;
        return (
            <Fragment>
                <ImageLoader className='cartoon-image' url={image} alt='uploaded picture' />
                <div className='rendered-fragment__label'>Uploaded Picture</div>
                <div className='cartoon-result'>
                    score:
                    {loading && <Spinner size={50} />}
                    {!loading && <div className='cartoon-score'>{classification}</div>}
                    {!loading && <div className='cartoon-ranking'>{getRanking(classification)}</div>}
                </div>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cartoonClassification/index.jsx